<script lang="ts">
    import {url, setQueryStringParameter} from '../url'

    export let pageSize: number;
    export let count: number;
    let pageNum: number;
    let pages: number[] = [];

    url.subscribe(url => {
        pageNum = Number(url.searchParams.get('p')) || 1;
        const minPage = Math.floor((pageNum - 1) / pageSize) * pageSize + 1
        const maxPage = Math.ceil(count / pageSize)

        if (pages.length === 0) {
            for (let i = minPage; i <= maxPage; i++) {
                pages.push(i);
            }
        }
    })

    function back() {
        setQueryStringParameter('p', String(pageNum - 1))
    }

    function forward() {
        setQueryStringParameter('p', String(pageNum + 1))
    }

    function first() {
        setQueryStringParameter('p', "1")
    }

    function last() {
        setQueryStringParameter('p', String(Math.ceil(count / pageSize)))
    }


</script>

<nav aria-label="...">
    <ul class="pagination">
        {#if pageNum != 1}
            <li class="page-item">
                <button class="page-link" on:click={first}>First</button>
            </li>
        {/if}
        {#if pageNum == 1}
            <li class="page-item">
                <button class="page-link disabled" on:click={first}>First</button>
            </li>
        {/if}
        {#if pageNum == 1}
        <li class="page-item">
            <button class="page-link disabled" on:click={back}>Previous</button>
        </li>
        {/if}
        {#if pageNum != 1}
            <li class="page-item">
                <button class="page-link" on:click={back}>Previous</button>
            </li>
        {/if}
        {#each pages as p}
            {#if (p <= pageNum && p > pageNum - 3) || (p > pageNum && p < pageNum + 3)}
                <li class="page-item">
                    <button on:click={() => setQueryStringParameter('p', String(p))} class="page-link" class:active={ p === pageNum }>{p}</button>
                </li>
            {/if}
        {/each}
        {#if pageNum == Math.ceil(count/pageSize)}
        <li class="page-item disabled">
            <button on:click={forward} class="page-link">Next</button>
        </li>
        {/if}
        {#if pageNum != Math.ceil(count/pageSize)}
            <li class="page-item">
                <button on:click={forward} class="page-link">Next</button>
            </li>
        {/if}
        {#if pageNum != Math.ceil(count/pageSize)}
            <li class="page-item">
                <button on:click={last} class="page-link">Last</button>
            </li>
        {/if}
        {#if pageNum == Math.ceil(count/pageSize)}
            <li class="page-item disabled">
                <button on:click={last} class="page-link">Last</button>
            </li>
        {/if}
    </ul>
</nav>

<style>
    .pagination  {
        --bs-pagination-active-bg: #007EC6;
        --bs-pagination-color: #007EC6;

    }
</style>
